import { attentionEnabled, attentionState } from './state';

export function unreadGroups(legacy) {
  if (!attentionEnabled()) return legacy;
  const account = Number(window.location.pathname.match(/\/app\/accounts\/(\d+)\//)?.[1]);
  if (account && account !== attentionState.snapshot?.account_id) return {};
  return attentionState.snapshot?.unseen_counts || {};
}

export function sortPersonalUnread(conversations, count) {
  const rank = value => value == null ? 0.5 : value > 0 ? value + 1 : 0;
  return [...conversations].sort((a,b) => rank(count(b)) - rank(count(a)) || (b.last_activity_at || 0) - (a.last_activity_at || 0));
}
